module.exports = __webpack_public_path__ + "img/windows-logo.4ea9a09b.svg";